import { buildGuidanceReportForLocale } from './guidance';
import type { ConsultationRequest, GuidanceReport, JourneyLocale, LeadRegistration, LeadSourceMetadata, MedicalInputs, UserPreferences } from './types';

export async function createPlan(preferences: UserPreferences, medical: MedicalInputs, locale: JourneyLocale = 'zh-Hans'): Promise<GuidanceReport> {
  const fallback = buildGuidanceReportForLocale(preferences, medical, locale);

  try {
    const response = await fetch('/api/plans', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ preferences, medical, locale })
    });
    if (!response.ok) return fallback;
    const data = (await response.json()) as { report: GuidanceReport };
    return data.report;
  } catch {
    return fallback;
  }
}

export async function submitLead(
  planId: string | undefined,
  lead: LeadRegistration,
  source: LeadSourceMetadata = {}
): Promise<{ ok: boolean; id?: string }> {
  try {
    const response = await fetch('/api/leads', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ planId, lead, ...source })
    });
    if (!response.ok) return { ok: false };
    return (await response.json()) as { ok: boolean; id: string };
  } catch {
    return { ok: false };
  }
}

export async function submitConsultation(consultation: ConsultationRequest): Promise<{ ok: boolean; id?: string }> {
  try {
    const response = await fetch('/api/leads', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ consultation })
    });
    if (!response.ok) return { ok: false };
    return (await response.json()) as { ok: boolean; id?: string };
  } catch {
    return { ok: false };
  }
}
